module.exports = __webpack_public_path__ + "img/graphic.d67a8a4b.svg";